import { useSelector } from "react-redux";
import ContentsPopup from "../../../ui/popup/contentPopup/ContentPopup";
import SimplePopup from "../../../ui/popup/SimplePopup";
import SecondaryBtn from "../../../ui/buttons/SecondaryBtn";
import PrimaryBtn from "../../../ui/buttons/PrimaryBtn";
import iconsList from "../../../ui/icons/iconsList";
import Icon from "../../../ui/icons/Icon";
import classes from "./ConfirmDeletePopup.module.css";


const ConfirmDeletePopup = ({ onClose, onClick, isSubmitting = false, text , confirmText}) => {

    const { texts } = useSelector((state) => state.translate);

    return (
        <SimplePopup close={onClose} dropClass={classes.ConfirmDeletePopupClass} dropClassClose={classes.DropClassClose}>
            <ContentsPopup className={classes.Content}>
                <p className={classes.Title}>{confirmText ||  texts.confirmDeleteTitle}</p>
                <Icon name={iconsList.confirm} size={38} color="#000" className={classes.Icon} />
                <p className={classes.Text}>{text ?? texts.confirmDeleteText}</p>
            </ContentsPopup>
            <div className={classes.Footer}>
                <SecondaryBtn color="var(--color-primary-button)" dropClass={`${classes.Cancel}`} onClick={() => onClose()} >
                    {texts.cancel}
                </SecondaryBtn>
                <PrimaryBtn dropClass={`${classes.Ok} ${classes.btn}`} onClick={() => onClick()}>
                    {isSubmitting ? texts.loadingPublishing : texts.ok}
                </PrimaryBtn>
            </div>
        </SimplePopup>
    )
}

export default ConfirmDeletePopup;